import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Tag,
  Tooltip,
  Popover,
  Button,
  Row,
  Pagination,
  message,
} from "antd";
import GetMerchantInvoices from "../../functions/invoice/getMerchantInvoices";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import MerchantInvoiceAdd from "../../components/modal/merchantInvoiceAdd";
import SearchMerchant from "../../components/search/searcMerchant";
import { FilterOutlined, RedoOutlined } from "@ant-design/icons";
import { useMerchant } from "../../context/merchantContext";
import SearchDatePickerInvoice from "../../components/search/datePickerInvoice";
import SearchPaymentMethodInvoice from "../../components/search/searchPaymentMethodInvoice";
import moneyFormat from "../../functions/utils/moneyFormat";
import requestCallback from "../../functions/invoice/requestCallback";
import TablePagination from "components/pagination/tablePagination";
import { bg_button, bg_shadow } from "constant/css";
import SearchMerchantNumber from "components/search/searcMerchantNumber";
import CheckPermission from "functions/utils/checkPermission";
import { getMerchantId } from "service/storage";

const MerchantCheckInvoice = () => {
  const merchantId = getMerchantId();
  const { showLoading, hideLoading } = useLoading();
  const {
    searchFieldsInvoice,
    setSearchFieldsInvoice,
    showFilter,
    setShowFilter,
  } = useMerchant();
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    prepareQueryStringAndSearch(page, pageSize);
  }, [page, pageSize]);
  useEffect(() => {
    setPage(1);
    prepareQueryStringAndSearch(1, pageSize);
  }, [searchFieldsInvoice]);
  const prepareQueryStringAndSearch = (page, size) => {
    //object fields length
    const searchFieldsLength = Object.keys(searchFieldsInvoice).length;
    var queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFieldsInvoice)
        .map((key) => {
          if (!searchFieldsInvoice[key]) return null;
          if (key.includes("At")) {
            // it is date
            return `${key}=${searchFieldsInvoice[key]
              .map((e, i) => {
                if (i === 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFieldsInvoice[key])}`;
        })
        .join("&");
    }
    fetchInvoices(queryString, page, size);
  };
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 20,
    },
    {
      title: <SearchMerchantNumber title="Нийт дүн" fieldName="amount" />,
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 120,
      render: (e) => moneyFormat(e),
    },
    {
      title: <span className="text-xs">Шимтгэл</span>,
      dataIndex: "feeAmount",
      key: "feeAmount",
      align: "right",
      width: 80,
    },
    {
      title: (
        <SearchMerchant
          select={[
            { value: null, title: "Сонго" },
            { value: "PAID", title: "Төлөгдсөн" },
            { value: "NOT_PAID", title: "Төлөгдөөгүй" },
          ]}
          title="Төлөв"
          fieldName="status"
        />
      ),
      dataIndex: "status",
      align: "center",
      key: "status",
      width: 100,
      render: (e) =>
        e === "PAID" ? (
          <Tag color="cyan" style={{ color: "#5fb3a5" }}>
            Төлөгдсөн
          </Tag>
        ) : (
          <Tag color="default">Төлөөгүй</Tag>
        ),
    },
    {
      title: (
        <SearchDatePickerInvoice
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center",
      width: 150,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: (
        <SearchPaymentMethodInvoice
          title="Төлбөрийн төрөл"
          fieldName="paymentMethodId"
        />
      ),
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      width: 80,
      align: "center",
      render: (e) => (e ? e.name : "-"),
    },
    {
      title: (
        <SearchMerchant
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "SUCCESS", title: "200 OK" },
            { value: "502", title: "502" },
            { value: "FAILED", title: "Бусад" },
          ]}
          title="Мерчант дуудалт"
          fieldName="callBackResponse"
        />
      ),
      dataIndex: "callBackResponse",
      key: "callBackResponse",
      width: 80,
      align: "center",
      render: (e, r) => {
        if (e == 502)
          return (
            <Tag color="error" onClick={() => reCallback(r)}>
              502
            </Tag>
          );
        if (e == 200) return <Tag color="cyan">200</Tag>;
        return <Tag color="default">-</Tag>;
      },
    },
    {
      title: (
        <SearchMerchant
          select={[
            { value: null, title: "Сонго" },
            { value: "HAS_USER", title: "Төлөгчтэй" },
            { value: "NO_USER", title: "Хоосон" },
          ]}
          title="Төлөгч"
          fieldName="userId"
        />
      ),
      dataIndex: "phone",
      key: "phone",
      width: 90,
      render: (e) => e,
    },
    {
      title: (
        <SearchMerchant
          select={[
            { value: null, title: "Сонго" },
            { value: "ONE", title: "Дан" },
            { value: "PACK", title: "Багц" },
          ]}
          title="Багц"
          fieldName="invoiceItemCount"
        />
      ),
      dataIndex: "invoiceItemCount",
      key: "invoiceItemCount",
      width: 70,
      align: "right",
      render: (e) =>
        e == 1 ? (
          <Tag color="blue">Дан</Tag>
        ) : (
          <Tag color="success">Багц(Тог)</Tag>
        ),
    },
  ];
  const invoiceItemColumns = [
    {
      title: <span className="text-xs">Нийт дүн</span>,
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: <span className="text-xs">НӨАТ</span>,
      dataIndex: "invoiceItemVatInfo",
      key: "invoiceItemVatInfo",
      render: (e) =>
        merchantId === 2 ? (
          <Tag color="cyan">Мерчант үүсгэх</Tag>
        ) : e?.status == "DONE" ? (
          <Popover title="VAT" content={<p>{JSON.stringify(e.qrJson)}</p>}>
            <Tag color="success">Үүссэн</Tag>
          </Popover>
        ) : (
          <Tag color="default">Үүссэгүй</Tag>
        ),
    },
    {
      title: <span className="text-xs">Утга</span>,
      dataIndex: "description",
      key: "id",
    },
    {
      title: (
        <Tooltip title="Мерчант-с өгсөн хаягыг төлөгдсөний дараа дуудсан статус">
          <span className="text-xs">Мэдээлэлсэн ?</span>
        </Tooltip>
      ),
      dataIndex: "callBackResponse",
      key: "callBackResponse",
      render: (e, r) =>
        !r.successCallback ? (
          "Хоосон"
        ) : e ? (
          String(e).includes("200") ? (
            <Tag color="cyan">200</Tag>
          ) : (
            <Tag color="error">{e}</Tag>
          )
        ) : (
          <Tag color="default">-</Tag>
        ),
    },
    {
      title: <span className="text-xs">Огноо</span>,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm:ss") : "-"),
    },
    {
      title: <span className="text-xs">Гүйлгээ</span>,
      dataIndex: "transaction",
      key: "transaction",
      render: (e) =>
        e ? (
          `${e.status} (${e.settleType})`
        ) : (
          <Tooltip title="Гүйлгээний утга тэст агуулсан тохиолдол гүйлгээ хийгдэхгүй">
            {" "}
            <Tag>?</Tag>
          </Tooltip>
        ),
    },
    {
      title: <span className="text-xs">Дата</span>,
      dataIndex: "data",
      key: "data",
      render: (e) =>
        e ? (
          <Tooltip title={JSON.stringify(e)}>
            {" "}
            <Tag>?</Tag>
          </Tooltip>
        ) : (
          ""
        ),
    },
  ];
  useEffect(() => {
    message.success("Таньд өнөөдрийн төлөлтүүдийг харуулж байна");
  }, []);
  const reCallback = async (record) => {
    showLoading();
    const response = await requestCallback(record.id);
    hideLoading();
    prepareQueryStringAndSearch(page, pageSize);
  };
  const fetchInvoices = async (queryString, page, size) => {
    showLoading();
    const merchantId = getMerchantId();
    const response = await GetMerchantInvoices(
      merchantId,
      `&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setSummary(response.summary);
      setPaginationData(response.pagination);
    }
  };
  const changePage = (page) => {
    setPage(page);
  };

  const addInvoice = (value) => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const changeSize = (current, size) => {
    setPageSize(size);
  };
  const refresh = () => {
    setPage(1);
    setSearchFieldsInvoice({});
  };
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };
  return (
    <div className="vatMerchantListontainer mt-3">
      <Row style={{ gap: 10 }}>
        <CheckPermission allow={2}>
          <div className="addButtonMerchant">
            <Button
              type="primary"
              className={`${bg_button} ${bg_shadow} rounded-xl`}
              onClick={addInvoice}
            >
              Нэхэмжлэл үүсгэх
            </Button>
          </div>
        </CheckPermission>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} ${bg_shadow} rounded-xl`}
            onClick={refresh}
          >
            <RedoOutlined />
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type={"primary"}
            className={`spayDefaultButton ${bg_button} ${bg_shadow}  rounded-xl ${
              !showFilter && "spayDefaultButtonInactive"
            }`}
            onClick={toggleFilter}
          >
            <FilterOutlined />
          </Button>
        </div>
      </Row>
      <div className={`${bg_shadow} rounded-xl p-3 mt-2`}>
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          size="small"
          className="text-xs"
          expandable={{
            expandedRowRender: (record) => (
              <Table
                columns={invoiceItemColumns}
                dataSource={record.invoiceItems}
                pagination={false}
              />
            ),
            rowExpandable: () => {
              return true;
            },
          }}
          onRow={(record) => ({
            onDoubleClick: () => {
              window.open(
                `https://smartbilling.mn/invoice?secureId=${record.secureId}`,
                "_blank"
              );
              // Add any additional logic here
            },
          })}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 28vh)",
          }}
          summary={(pageData) => {
            return (
              <Table.Summary fixed>
                <Table.Summary.Row className="">
                  <Table.Summary.Cell
                    index={0}
                    align="right"
                  ></Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={1}
                    align="right"
                  ></Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="right">
                    {summary ? moneyFormat(summary.totalAmount) : 0}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="right">
                    {summary ? moneyFormat(summary.feeAmount) : 0}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
          pagination={false}
          dataSource={data}
        ></Table>
        <TablePagination
          page={page}
          paginationData={paginationData}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      {openModal && (
        <MerchantInvoiceAdd
          open={openModal}
          close={closeModal}
          refresh={refresh}
        />
      )}
    </div>
  );
};

export default MerchantCheckInvoice;
